

export default function ArticleMetaTags(){
  const meta = {
    title: 'Articles',
    description: 'Doge Algo Articles',
    canonical: '/article',
    meta: {
      charset: 'utf-8',
      name: {
        keywords: `BALANCE: Link Flooding Attack Detection and Mitigation via Hybrid-SDN,
                   OpenAI Codex - The Model behind GitHub Copilots,
                   Object Pool Design Pattern : Fictional Example of
                   Allocating Battle Royal Game Room to Players or vice versa,
                   8 categories of Git,How to prepare custom image dataset,
                   split as train set & test set and build a CNN model using Keras?,
                   How a Single Mathematical question lead to the Invention of Modern Computers?,
                   How to do your first contribution with an Open Source project in GitHub ?,
                   SQL Joins,How to install Github Desktop for Ubuntu & Debian?,
                   How to recover our commit after a git reset --hard ?,
                   How classmethod in Python helps in implementing Factory methods ?,
                   Interesting_Usages_ of_UNDERSCORE _in_SCALA,
          `
      }
    }
  };
  return meta;
}
